import gql from 'graphql-tag';
import { SECRETARY_OF_STATE_REPORT_FRAGMENT } from './fragments/secretaryOfStateReportFragment';

export const GET_SECRETARY_OF_STATE_REPORT = gql`
  query SecretaryOfStateReport($input: GetSecretaryOfStateReportInput!) {
    cobaltIntelligence {
      result: secretaryOfStateReport(input: $input) {
        error
        success
        entity {
          ...SecretaryOfStateReportViewModel
        }
      }
    }
  }
  ${SECRETARY_OF_STATE_REPORT_FRAGMENT}
`;
